import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import AdminSidebar from '../components/AdminSidebar';
import '../style/common.css';

function VendorMaterialManager() {
  const [jcNumber, setJcNumber] = useState('');
  const [vendorName, setVendorName] = useState('');
  const [material, setMaterial] = useState({ item_name: '', unit: '', quantity: '', price: '', gst: '' });
  const [materials, setMaterials] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [activeTab, setActiveTab] = useState('manual');

  const unitSuggestions = ["Pcs", "Pkt", "Trip", "Pair", "Set", "Mtr", "Nos", "Box", "Roll", "Bag", "Bucket", "Kg"];

  const calculateTotal = (qty, price, gst) => {
    const base = qty * price;
    return base + (base * gst / 100);
  };

  const handleAddMaterial = () => {
    const total = calculateTotal(Number(material.quantity), Number(material.price), Number(material.gst));
    setMaterials(prev => [...prev, { ...material, total }]);
    setMaterial({ item_name: '', unit: '', quantity: '', price: '', gst: '' });
  };

  const handleSubmit = async () => {
    if (!jcNumber || !vendorName || materials.length === 0) {
      alert("All fields required.");
      return;
    }

    const payload = {
      jc_number: jcNumber,
      vendor_name: vendorName,
      materials: materials
    };

    try {
      const response = await fetch('https://ideatorportal.in/api/save_material.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.status === 'success') {
        alert('Data saved successfully');
        setMaterials([]);
        setVendorName('');
        setJcNumber('');
      } else {
        alert('Something went wrong');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('Submission failed');
    }
  };

  const handleExcelUpload = async () => {
    if (!uploadFile) return alert('Please select a file');

    const reader = new FileReader();
    reader.onload = async (e) => {
      const wb = XLSX.read(e.target.result, { type: 'binary' });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet);

      // Group by JC Number and Vendor Name
      const grouped = {};

      rows.forEach(row => {
        const key = `${row['JC Number']}|${row['Vendor Name']}`;
        if (!grouped[key]) {
          grouped[key] = {
            jc_number: row['JC Number'],
            vendor_name: row['Vendor Name'],
            materials: []
          };
        }
        grouped[key].materials.push({
          item_name: row['Item Name'],
          unit: row['Unit'],
          quantity: Number(row['Quantity']),
          price: Number(row['Price']),
          gst: Number(row['GST (%)'])
        });
      });

      try {
        for (const key in grouped) {
          const payload = grouped[key];

          const response = await fetch('https://ideatorportal.in/api/save_material.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          const result = await response.json();
          if (result.status !== 'success') {
            alert(`Failed to upload for ${payload.jc_number} - ${payload.vendor_name}`);
          }
        }

        alert('Bulk data uploaded successfully');
      } catch (error) {
        console.error('Batch upload error:', error);
        alert('Batch submission failed');
      }
    };

    reader.readAsBinaryString(uploadFile);
  };

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar />
      <div className="dashboard-content">
        <h2>Vendor Material Manager</h2>

        <div style={{ marginBottom: '1.5rem' }}>
          <button onClick={() => setActiveTab('manual')} style={{ marginRight: 10, backgroundColor: activeTab === 'manual' ? '#007bff' : '#e0e0e0', color: activeTab === 'manual' ? '#fff' : '#000' }}>
            Manual Upload
          </button>
          <button onClick={() => setActiveTab('bulk')} style={{ backgroundColor: activeTab === 'bulk' ? '#007bff' : '#e0e0e0', color: activeTab === 'bulk' ? '#fff' : '#000' }}>
            Bulk Upload (Excel)
          </button>
        </div>

        {activeTab === 'manual' && (
          <>
            <input placeholder="JC Number" value={jcNumber} onChange={e => setJcNumber(e.target.value)} />
            <input placeholder="Vendor Name" value={vendorName} onChange={e => setVendorName(e.target.value)} />
            <h4>Add Material</h4>
            <input placeholder="Item Name" value={material.item_name} onChange={e => setMaterial({ ...material, item_name: e.target.value })} />
            <input list="unit-suggestions" placeholder="Unit" value={material.unit} onChange={e => setMaterial({ ...material, unit: e.target.value })} />
            <datalist id="unit-suggestions">{unitSuggestions.map((u, idx) => <option key={idx} value={u} />)}</datalist>
            <input type="number" placeholder="Quantity" value={material.quantity} onChange={e => setMaterial({ ...material, quantity: e.target.value })} />
            <input type="number" placeholder="Price" value={material.price} onChange={e => setMaterial({ ...material, price: e.target.value })} />
            <input type="number" placeholder="GST (%)" value={material.gst} onChange={e => setMaterial({ ...material, gst: e.target.value })} />
            <button onClick={handleAddMaterial}>Add Material</button>
            <ul>
              {materials.map((mat, idx) => (
                <li key={idx}>{mat.item_name} - {mat.quantity} {mat.unit} @ ₹{mat.price} + {mat.gst}%</li>
              ))}
            </ul>
            <button onClick={handleSubmit}>Save Vendor & Materials</button>
          </>
        )}

        {activeTab === 'bulk' && (
          <>
            <input type="file" accept=".xlsx, .xls" onChange={(e) => setUploadFile(e.target.files[0])} />
            <button onClick={handleExcelUpload}>Upload Excel</button>
          </>
        )}
      </div>
    </div>
  );
}

export default VendorMaterialManager;
